import React, { Component } from "react";
import { Row, Col, Table, Drawer, Button, Popover, message } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import "./TenderList.css";
import TenderAdd from "../TenderAdd/TenderAdd";
import PlusIcon from "../../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../../Components/MyComponent/ButtonLinkIcon";
import FilterIcon from "../../../svg/svgicon/FilterIcon";
import MenuVertical from "../../../Components/MyComponent/MenuVertical";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import { API } from "../../../API/API";
import Search from "../../../Components/Search/Search";
const forExcelCol = [
  {
    title: "Код",
    dataIndex: "tendercode",
  },
  {
    title: "Тендерийн шалгаруулалт",
    dataIndex: "tendername",
  },
  {
    title: "Захиалагч",
    dataIndex: "departmentname",
  },
  {
    title: "Төрөл",
    dataIndex: "tendertypename",
  },
  {
    title: "ХАА-ын арга",
    dataIndex: "purchasetypename",
  },
  {
    title: "Тендер нийтлэх хугацаа",
    dataIndex: "publishdate",
  },
  {
    title: "Хүлээн авах хугацаа",
    dataIndex: "acceptdate",
  },
  {
    title: "Тендер нээх хугацаа",
    dataIndex: "opendate",
  },
  {
    title: "Төлөв",
    dataIndex: "statusname",
  },
];
class TenderList extends Component {
  state = {
    dataFilter: [],
    data: [],
    showNewInputForm: false,
    showMenu: false,
    selectedTenderId: 0,
    isEdit: false,
    sortedInfo: null,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getTenderList").then((response) => {
      if (response.status === 200) {
        this.setState({
          data: response.data.retData,
          dataFilter: response.data.retData,
        });
      }
    });
  };
  content = (record, show) => {
    return show ? <MenuVertical istender={true} isedit={record.status === 0 ? true : false} onMenuChange={(e) => this.onMenuChange(e, record)} /> : null;
  };
  onChangeShowMenu = (show) => {
    this.setState({ showMenu: show })
  }
  onMenuChange = (e, record) => {
    if (e.key == 3) {
      this.props.history.push(
        "/invitation/0/" +
        record.tenderid +
        "/" +
        record.tendername +
        "/" +
        record.departmentname +
        "/" +
        record.tendertypename +
        "/" +
        record.purchasetypename +
        "/" +
        record.budget +
        "/" +
        record.isedit +
        "/" +
        false
      );
    } else if (e.key == 2) {
      this.content(record, false);
      API.get("/deleteTender?tenderid=" + record.tenderid).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Амжилттай устгагдлаа.");
          this.getData();
        }
      });
    } else if (e.key == 1) {
      this.showNewInputFormHandler(true, record.tenderid, true);
    }
  };
  showNewInputFormHandler = (show, tenderid, isedit) => {
    this.setState({
      showMenu: false,
      showNewInputForm: show,
      selectedTenderId: tenderid,
      isEdit: isedit,
    });
    if (show === false) {
      this.getData();
    }
  };
  onSearch = (pvalue) => {
    let tTableData = [...this.state.data];
    if (pvalue) {
      tTableData = tTableData.filter(r => {
        if (String(r.tendercode).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.tendername).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.departmentname).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.tendertypename).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.purchasetypename).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.statusname).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.publishdate).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.opendate).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
          || String(r.acceptdate).toLowerCase().indexOf(pvalue.toString().toLowerCase()) >= 0
        ) {
          return true;
        } else {
          return false
        }
      });
    } else {
      tTableData = [...this.state.data];
    }
    this.setState({ dataFilter: tTableData });
  };
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter,
    });
  };
  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: "Код",
        dataIndex: "tendercode",
        key: "tendercode",
        width: "12%",
        align: "left",
        sorter: (a, b) => a.tendercode.localeCompare(b.tendercode),
        sortOrder: sortedInfo.columnKey === 'tendercode' && sortedInfo.order,
        render: (text, record) => {
          return (
            <Button
              style={{ fontWeight: "500", color: "#0358A7" }}
              type="link"
              onClick={() =>
                this.showNewInputFormHandler(true, record.tenderid, false)
              }
            >
              {record.tendercode}
            </Button>
          );
        },
      },
      {
        title: "Тендерийн шалгаруулалт",
        dataIndex: "tendername",
        key: "tendername",
        width: "18%",
        align: "left",
        sorter: (a, b) => a.tendername.localeCompare(b.tendername),
        sortOrder: sortedInfo.columnKey === 'tendername' && sortedInfo.order,
      },
      {
        title: "",
        dataIndex: "option",
        key: "option",
        width: "3%",
        align: "left",
        render: (text, record) => {
          return (
            <div key={record.tenderid}>
              <Popover
                placement="bottom"
                content={this.content(record, true)}
                trigger="click"
              >
                <Button style={{ color: "#979797" }} type="link">
                  <MoreOutlined style={{ fontSize: '120%' }} />
                </Button>
              </Popover>
            </div>
          );
        },
      },
      {
        title: "Захиалагч",
        dataIndex: "departmentname",
        key: "departmentname",
        width: "15%",
        align: "left",
        sorter: (a, b) => a.departmentname ? a.departmentname.localeCompare(b.departmentname) : null,
        sortOrder: sortedInfo.columnKey === 'departmentname' && sortedInfo.order,
      },
      {
        title: "Төрөл",
        dataIndex: "tendertypename",
        key: "tendertypename",
        width: "10%",
        align: "left",
        sorter: (a, b) => a.tendertypename ? a.tendertypename.localeCompare(b.tendertypename) : null,
        sortOrder: sortedInfo.columnKey === 'tendertypename' && sortedInfo.order,
      },
      {
        title: "ХАА-ын арга",
        dataIndex: "purchasetypename",
        key: "purchasetypename",
        width: "10%",
        align: "left",
        sorter: (a, b) => a.purchasetypename ? a.purchasetypename.localeCompare(b.purchasetypename) : null,
        sortOrder: sortedInfo.columnKey === 'purchasetypename' && sortedInfo.order,
      },
      {
        title: "Тендер нийтлэх хугацаа",
        dataIndex: "publishdate",
        key: "publishdate",
        width: "10%",
        align: "left",
      },
      {
        title: "Хүлээн авах хугацаа",
        dataIndex: "dateinterval",
        key: "dateinterval",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.acceptdate}
            </div>
          );
        },
      },
      {
        title: "Тендер нээх хугацаа",
        dataIndex: "dateinterval",
        key: "dateinterval",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.opendate}
            </div>
          );
        },
      },
      {
        title: "Төлөв",
        dataIndex: "statusname",
        key: "statusname",
        width: "10%",
        align: "left",
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Тендерийн жагсаалт</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0, true)}
                  icon={<PlusIcon />}
                  name="Тендер нэмэх"
                />
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row
              style={{ height: 56 }}
              justify="end"
              align="middle"
              gutter={[16, 16]}
            >
              <Col>
                <Search
                  search={(value) => this.onSearch(value)}
                  placeholder="Хайх..."
                ></Search>
              </Col>
              <Col style={{ marginRight: 10 }}>
                <ExportExcel
                  fileName={"Тендерийн жагсаалт"}
                  column={forExcelCol}
                  dataSource={this.state.data}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="tender-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.dataFilter}
            onChange={this.handleChange}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            rowKey="tenderid"
            scroll={{ y: 500 }}
            pagination={false}
          />
        </div>
        <Drawer
          title="Тендер нэмэх"
          width="960px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0, false)}
          destroyOnClose={true}
        >
          <TenderAdd
            tenderid={this.state.selectedTenderId}
            showForm={this.showNewInputFormHandler}
            isEdit={this.state.isEdit}
          ></TenderAdd>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(TenderList);
